import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const InhouseInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Inhouse"
    sectionDisplayName="Inhouse Section"
    backRoute="/sections/inhouse"
  />
);

export default InhouseInwardConsignment;
